import React from 'react';
import { Row, Col } from 'antd';

import ByPhoneOrAccountNumber from './byPhoneOrAccountNumber/ByPhoneOrAccountNumber';

const SendMoneyView = () => {
  return (
    <>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ByPhoneOrAccountNumber />
        </Col>
        <Col span={24}>
          <ByPhoneOrAccountNumber isByAccount />
        </Col>
      </Row>
    </>
  );
};

export default SendMoneyView;
